import { useState } from "react";
import Spacer from "./Spacer";
import { connect } from "react-redux";
import AiCreditIncrement from "../../views/aiAssistant/AiCreditIncrement";
import AiIcon from "assets/icons/aiIcon-colored.svg";
import Button from "components/global/Button";
import styled from "styled-components";

const Wrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 450;
  background-color: #f7fafd;
  gap: 6px;
  border-radius: 8px;
  color: var(--secondary);
  display: flex;
  align-items: center;
  padding: 4px 4px 4px 8px;
  gap: 8px;

  img {
    width: 16px;
    height: 16px;
  }

  .btn {
    font-size: 12px;
  }

  @media (max-width: 768px) {
    .aiContent {
      span,
      img {
        display: none;
      }
    }
  }
`;

const AiCreditGlobal = ({ active_account, setOpenBuyCreditModal }) => {
  return (
    <>
      <Wrapper>
        <div className="flexRow alignCenter aiContent">
          <img src={AiIcon} alt="ai" width="20px" height="20px" />
          <Spacer x={0.6} />
          {active_account?.total_ai_credits} <Spacer x={0.2} /> <span>AI</span>
        </div>
        <Button
          type="button"
          text="Buy"
          className="l4 btn"
          bg="var(--primary)"
          height="36px"
          onClick={() => setOpenBuyCreditModal(true)}
        />
      </Wrapper>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    active_account: state.active_account,
  };
};

export default connect(mapStateToProps)(AiCreditGlobal);
